import * as flatbuffers from 'flatbuffers'
import { tbs } from './engine/bindings/typescript/engine'
import { EngineInstance } from './engine_wrapper'

export async function runEngineSmokeTest(): Promise<void> {
  const engine = await EngineInstance.create()
  const stateInfo = engine.runMapScript()
  console.info(`[engine-test] initial payload: ${stateInfo.payloadName} (${stateInfo.length} bytes)`)

  const handle = engine.createGameFromState(stateInfo.bytes)
  console.info(`[engine-test] created game handle ${handle}`)

  const builder = new flatbuffers.Builder(1024)
  tbs.ActionEnvelope.startActionEnvelope(builder)
  tbs.ActionEnvelope.addActionType(builder, tbs.ActionPayload.StartTurnAction)
  const actionEnvelope = tbs.ActionEnvelope.endActionEnvelope(builder)
  tbs.EngineMessage.startEngineMessage(builder)
  tbs.EngineMessage.addPayloadType(builder, tbs.EnginePayload.ActionEnvelope)
  tbs.EngineMessage.addPayload(builder, actionEnvelope)
  const envelope = tbs.EngineMessage.endEngineMessage(builder)
  builder.finish(envelope)

  const actionBytes = builder.asUint8Array()
  const actionResult = engine.applyAction(handle, actionBytes)
  console.info(`[engine-test] apply_action result: ${actionResult}`)

  console.time('getFullState')
  const nextStateInfo = engine.getFullState(handle)
  console.timeEnd('getFullState')
  console.info(`[engine-test] post-action payload: ${nextStateInfo.payloadName} (${nextStateInfo.length} bytes)`)
  console.log('[engine-test] full state object', nextStateInfo.messageObject)
  const payload = nextStateInfo.messageObject.payload
  if (payload instanceof tbs.StateEnvelopeT) {
    console.log(payload.state)
  }
}
